const es = {
  common: {
    brand: "Consultants Sparks",
    tagline: "Proyectos. Personas. Crecimiento.",
    menu: "Menú",
    close: "Cerrar",
    loading: "Cargando…",
    save: "Guardar",
    saving: "Guardando…",
    cancel: "Cancelar",
    submit: "Enviar",
    back: "Volver",
    next: "Siguiente",
    previous: "Anterior",
    required: "Obligatorio",
    optional: "opcional",
    yes: "Sí",
    no: "No",
    search: "Buscar",
    filters: "Filtros",
    clear: "Restablecer",
    all: "Todos",
    none: "Ninguno",
    language: "Idioma",
    error: "Ha ocurrido un error. Inténtelo de nuevo.",
  },
  nav: {
    home: "Inicio",
    about: "Acerca de",
    opportunities: "Oportunidades",
    realEstate: "Inmobiliario",
    careers: "Carreras",
    humanDev: "Desarrollo humano",
    projects: "Proyectos",
    contact: "Contacto",
  },
  cta: {
    discover: "Descubrir las oportunidades",
    apply: "Enviar mi candidatura",
    talk: "Hablar con nuestro equipo",
    exploreRealEstate: "Explorar una carrera inmobiliaria",
    login: "Iniciar sesión",
    register: "Crear una cuenta",
    portal: "Mi portal",
    admin: "Administración",
    logout: "Cerrar sesión",
  },
  home: {
    heroKicker: "Proyectos. Personas. Crecimiento.",
    heroL1: "Desarrollar los proyectos.",
    heroL2: "Revelar el potencial.",
    heroL3: "Crear el crecimiento.",
    heroSub: "Consultants Sparks acompaña a las personas, los equipos y las organizaciones en el desarrollo de nuevas oportunidades, proyectos y carreras.",
    pillarsKicker: "Tres pilares",
    pillars: {
      projects: { title: "Proyectos", body: "Contribuimos a transformar las oportunidades en iniciativas estructuradas y duraderas." },
      people: { title: "Personas", body: "Identificamos, desarrollamos y acompañamos a las personas listas para evolucionar." },
      growth: { title: "Crecimiento", body: "Creamos conexiones entre talento, organizaciones y oportunidades." },
    },
    journeyKicker: "El recorrido",
    journeyTitle: "Un acompañamiento estructurado, del primer contacto al liderazgo",
    journeyLead: "Cada persona avanza a su ritmo. Nuestro papel es hacer que cada etapa sea clara y alcanzable.",
    journey: [
      { title: "Descubrir", body: "Comprender hacia dónde puede llevarle su potencial." },
      { title: "Evaluar", body: "Una conversación humana para situar sus fortalezas y objetivos." },
      { title: "Orientar", body: "Identificar la dirección profesional más coherente." },
      { title: "Formar", body: "Desarrollar las competencias necesarias para tener éxito." },
      { title: "Incorporar", body: "Comenzar en un rol concreto, con acompañamiento." },
      { title: "Desarrollar", body: "Progresar, asumir responsabilidades y ayudar a otros a crecer." },
    ],
    verticalsKicker: "Ámbitos de actividad",
    verticalsTitle: "Sectores variados, una misma exigencia",
    verticalsLead: "Nuestros ámbitos evolucionan con las necesidades de las personas y organizaciones que acompañamos.",
    orgKicker: "Para organizaciones y proyectos",
    orgTitle: "Estructurar equipos, activar oportunidades",
    orgBody: "Trabajamos con organizaciones y responsables de proyectos para identificar talento, estructurar equipos, desarrollar mercados y crear alianzas duraderas.",
    orgItems: [
      "Identificar y atraer a las personas adecuadas",
      "Estructurar y desarrollar equipos",
      "Desarrollar nuevos mercados",
      "Crear alianzas duraderas",
    ],
    closingTitle: "¿Hacia dónde puede llevarle su potencial?",
    closingBody: "No necesita saber exactamente qué camino le corresponde. Empiece con una conversación.",
  },
  about: {
    kicker: "Acerca de",
    title: "Una organización que desarrolla proyectos y personas",
    lead: "Consultants Sparks es una organización de desarrollo: de proyectos, personas, equipos y crecimiento.",
    p1: "No somos una agencia de colocación ni un portal de empleo. Nuestro trabajo consiste en crear vínculos duraderos entre las ambiciones de las personas y las necesidades reales de las organizaciones y los proyectos.",
    p2: "Nuestro enfoque es estructurado, humano y verificable. Avanzamos por etapas claras, con decisiones tomadas por personas, nunca por automatismos.",
    valuesKicker: "Nuestros principios",
    values: [
      { title: "Rigor", body: "Procesos claros, documentados y respetuosos con las personas." },
      { title: "Confidencialidad", body: "Las relaciones comerciales y los datos personales permanecen protegidos." },
      { title: "Progresión", body: "Una organización crece cuando crecen las personas que la componen." },
    ],
    scaleKicker: "Nuestro alcance",
    scaleTitle: "Diseñado para crecer",
    scaleBody: "Nuestra arquitectura organizativa está pensada para operar a nivel local, provincial/estatal, nacional e internacional.",
    scaleItems: ["Local", "Provincial / Estatal", "Nacional", "Internacional"],
  },
  opportunities: {
    kicker: "Oportunidades",
    title: "Explorar las grandes categorías de oportunidades",
    lead: "Estas son las categorías generales en las que Consultants Sparks desarrolla personas, equipos y proyectos.",
    note: "Estas categorías son indicativas. No se publica ninguna oferta específica en esta página; las oportunidades concretas se conversan directamente con nuestro equipo.",
    categoriesTitle: "Categorías",
    cats: {
      real_estate_career: { title: "Carrera inmobiliaria", body: "Desarrollo de carrera, equipos y redes en el sector inmobiliario." },
      insurance_career: { title: "Carrera en seguros y servicios financieros", body: "Vías de entrada, cualificaciones requeridas y desarrollo consultivo." },
      sales_representative: { title: "Representación comercial", body: "Venta consultiva, captación de clientes y desarrollo de territorio." },
      campaign_representative: { title: "Representación en campañas", body: "Campañas comerciales, activaciones y proyectos solidarios." },
      business_development: { title: "Desarrollo de negocios", body: "Creación de oportunidades, alianzas y crecimiento organizacional." },
      automotive_sales: { title: "Sector automotriz", body: "Oportunidades comerciales y de desarrollo en la industria automotriz." },
      leadership_development: { title: "Desarrollo del liderazgo", body: "Acompañamiento a personas que desean dirigir y hacer crecer equipos." },
      project_opportunity: { title: "Oportunidad de proyecto", body: "Participación en proyectos estructurados, en desarrollo o expansión." },
    },
  },
  realEstate: {
    kicker: "Inmobiliario",
    title: "Desarrollar talento, equipos y proyectos inmobiliarios",
    lead: "Consultants Sparks acompaña el desarrollo de talento, redes, equipos y oportunidades en el sector inmobiliario.",
    p1: "El sector inmobiliario es una vertical importante de nuestra actividad: carreras, desarrollo de redes, estructuración de equipos de venta y proyectos de desarrollo.",
    p2: "Trabajamos con una red internacional de profesionales inmobiliarios y socios especializados. Por respeto a la confidencialidad, no se publica ningún nombre de socio sin autorización explícita.",
    areasKicker: "Ámbitos de acción",
    areas: [
      { title: "Carreras", body: "Acompañamiento a personas que desean construir una carrera inmobiliaria." },
      { title: "Desarrollo de redes", body: "Crecimiento y estructuración de redes profesionales." },
      { title: "Equipos de venta", body: "Construcción y desarrollo de equipos de alto rendimiento." },
      { title: "Proyectos de desarrollo", body: "Contribución a proyectos residenciales y comerciales." },
      { title: "Alianzas", body: "Creación de relaciones duraderas con socios especializados." },
      { title: "Expansión internacional", body: "Desarrollo de mercados más allá de las fronteras." },
    ],
  },
  humanDev: {
    kicker: "Desarrollo humano",
    title: "Una organización crece cuando crecen las personas que la componen",
    lead: "El desarrollo humano está en el centro de Consultants Sparks.",
    p1: "Acompañamos a las personas en el descubrimiento de su potencial, el desarrollo de sus competencias y la construcción de una trayectoria profesional coherente.",
    disclaimer: "No prometemos ningún ingreso ni garantizamos ninguna progresión automática. Cada trayectoria depende del compromiso, las competencias y el contexto de la persona.",
    itemsKicker: "Nuestro acompañamiento",
    items: [
      { title: "Acompañamiento", body: "Un seguimiento humano, estructurado y respetuoso del ritmo de cada persona." },
      { title: "Liderazgo", body: "Desarrollar la capacidad de dirigir, decidir y hacer crecer a otros." },
      { title: "Carrera", body: "Construir una trayectoria coherente, etapa por etapa." },
      { title: "Formación", body: "Adquirir las competencias necesarias para el rol deseado." },
      { title: "Coaching", body: "Conversaciones regulares para progresar de forma concreta." },
      { title: "Progresión", body: "Asumir responsabilidades y contribuir a proyectos más amplios." },
    ],
  },
  projects: {
    kicker: "Proyectos",
    title: "Transformar oportunidades en proyectos estructurados",
    lead: "Consultants Sparks desarrolla proyectos: comerciales, inmobiliarios, de expansión, de reclutamiento o de alianza.",
    p1: "Un proyecto rara vez comienza con un plan completo. Comienza con una oportunidad, un equipo y un método.",
    typesKicker: "Tipos de proyectos",
    types: [
      { title: "Inmobiliario", body: "Proyectos residenciales, comerciales y de desarrollo." },
      { title: "Comercial", body: "Desarrollo de mercados y oportunidades de negocio." },
      { title: "Expansión", body: "Crecimiento territorial y organizacional." },
      { title: "Reclutamiento", body: "Estructuración de equipos y capacidades humanas." },
      { title: "Alianza", body: "Alianzas estructuradas entre organizaciones." },
      { title: "Inversión", body: "Proyectos que requieren estructuración financiera." },
    ],
    processKicker: "Nuestro método",
    process: [
      { title: "Exploración", body: "Comprender la oportunidad y su contexto." },
      { title: "Cualificación", body: "Validar la viabilidad y las condiciones de éxito." },
      { title: "Estructuración", body: "Definir el equipo, las etapas y las responsabilidades." },
      { title: "Desarrollo", body: "Ejecutar, medir y ajustar." },
    ],
  },
  careers: {
    kicker: "Carreras",
    title: "Encuentre su próxima oportunidad",
    lead: "Descubra hacia dónde puede llevarle su potencial. Una sola candidatura general basta para iniciar la conversación.",
    howKicker: "Cómo funciona",
    how: [
      { title: "Enviar", body: "Complete la candidatura general en unos minutos." },
      { title: "Conversar", body: "Un miembro de nuestro equipo se pone en contacto con usted." },
      { title: "Orientar", body: "Identificamos juntos la dirección más coherente." },
      { title: "Comenzar", body: "Empieza con un acompañamiento estructurado." },
    ],
    noFake: "No publicamos ofertas ficticias. Las oportunidades concretas se presentan directamente durante nuestras conversaciones.",
  },
  contactAdmin: {
    title: "Mensajes de contacto",
    lead: "Mensajes recibidos por el formulario público, con su estado de sincronización con el CRM VytaliLeads.",
    empty: "Todavía no hay mensajes.",
    select: "Seleccione un mensaje.",
    syncLabel: "Sincronización CRM",
    attempts: "intento(s)",
    resend: "Reenviar al CRM",
    filterAll: "Todos",
    filterFailed: "Para reenviar",
    filterUnread: "Nuevos",
    noUnread: "No hay mensajes nuevos.",
    source: "Origen",
    sourceUnknown: "Origen desconocido",
    srcPage: "Página",
    srcLanding: "Página de llegada",
    srcLanguage: "Idioma",
    srcChannel: "Canal",
    srcReferrer: "Referente",
    noFailed: "No hay mensajes para reenviar.",
    resendOk: "Mensaje reenviado al CRM.",
    resendFailed: "El reenvío falló. El mensaje sigue guardado.",
    notConfigured: "La conexión servidor a servidor de VytaliLeads no está configurada. Los mensajes se guardan aquí y podrán reenviarse cuando la configuración esté lista.",
  },
  contact: {
    kicker: "Contacto",
    title: "Hablar con nuestro equipo",
    lead: "¿Una pregunta, un proyecto, una candidatura? Escríbanos.",
    name: "Nombre completo",
    email: "Correo electrónico",
    subject: "Asunto",
    message: "Mensaje",
    send: "Enviar mensaje",
    success: "Gracias. Su mensaje ha sido enviado a nuestro equipo.",
  },
  apply: {
    kicker: "Candidatura general",
    title: "Descubra hacia dónde puede llevarle su potencial",
    lead: "No necesita saber exactamente qué camino le corresponde. Responda y le orientaremos.",
    steps: ["Sus datos", "Su experiencia", "Sus intereses", "Consentimientos"],
    fields: {
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      phone: "Teléfono",
      city: "Ciudad",
      provinceState: "Provincia / Estado",
      country: "País",
      language: "Idioma preferido",
      employmentStatus: "Situación actual",
      currentRole: "Puesto actual",
      yearsExperience: "Años de experiencia",
      education: "Formación",
      availability: "Disponibilidad",
      transportation: "Transporte",
      experienceTitle: "Experiencia relevante",
      sales: "Experiencia en ventas",
      leadership: "Experiencia en liderazgo",
      realEstate: "Experiencia inmobiliaria",
      insurance: "Experiencia en seguros",
      automotive: "Experiencia en el sector automotriz",
      entrepreneurship: "Experiencia emprendedora",
      mobilityTitle: "Movilidad",
      travel: "Dispuesto a viajar",
      remote: "Interés en el trabajo a distancia",
      relocation: "Abierto a la reubicación",
      interests: "Ámbitos de interés",
      careerGoals: "Objetivos profesionales",
      motivation: "Lo que le motiva",
      referralSource: "¿Cómo nos conoció?",
    },
    options: {
      employment: { employed: "Empleado", self_employed: "Autónomo", student: "Estudiante", between_jobs: "En transición", other: "Otro" },
      years: { "0-1": "0 a 1 año", "2-3": "2 a 3 años", "3-5": "3 a 5 años", "5-10": "5 a 10 años", "10+": "Más de 10 años" },
      education: { high_school: "Secundaria", college: "Formación técnica", university: "Universitario", other: "Otro" },
      availability: { immediate: "Inmediata", "2_weeks": "En 2 semanas", "1_month": "En 1 mes", flexible: "Flexible" },
      transportation: { car: "Automóvil", public: "Transporte público", none: "Ninguno" },
      referral: { web: "Búsqueda web", social: "Redes sociales", referral: "Referencia de una persona", event: "Evento", other: "Otro" },
    },
    consent: {
      age: "Confirmo que tengo 18 años o más.",
      process: "Autorizo a Consultants Sparks a tratar mis datos para la evaluación de mi candidatura.",
      marketing: "Acepto recibir comunicaciones sobre oportunidades y actividades de Consultants Sparks (opcional).",
      version: "Versión del consentimiento",
      separateNote: "El consentimiento para tratar la candidatura es distinto del consentimiento para comunicaciones de marketing.",
    },
    ageError: "Debe confirmar que tiene 18 años o más.",
    consentError: "Se requiere el consentimiento para tratar su candidatura.",
    validation: {
      stepError: "Complete los campos obligatorios de esta etapa antes de continuar.",
      required: "Este campo es obligatorio.",
      email: "Introduzca una dirección de correo electrónico válida.",
      phone: "Introduzca un número de teléfono válido (al menos 6 caracteres).",
      country: "Introduzca un país válido.",
    },
    success: {
      title: "Candidatura recibida",
      body: "Gracias. Su candidatura ha sido registrada y un miembro de nuestro equipo se pondrá en contacto con usted.",
      account: "Cree su cuenta para seguir la evolución de su expediente.",
    },
  },
  auth: {
    loginTitle: "Iniciar sesión",
    loginLead: "Acceda a su portal Consultants Sparks.",
    registerTitle: "Crear una cuenta",
    registerLead: "Cree su cuenta para seguir su expediente.",
    email: "Correo electrónico",
    password: "Contraseña",
    firstName: "Nombre",
    lastName: "Apellido",
    forgotLink: "¿Olvidó su contraseña?",
    noAccount: "¿Aún no tiene cuenta?",
    hasAccount: "¿Ya tiene una cuenta?",
    forgotTitle: "Contraseña olvidada",
    forgotLead: "Le enviaremos un enlace de restablecimiento.",
    forgotSent: "Si existe una cuenta, se ha enviado un enlace de restablecimiento.",
    resetTitle: "Nueva contraseña",
    resetLead: "Elija una nueva contraseña.",
    resetDone: "Contraseña actualizada. Ya puede iniciar sesión.",
    verifyTitle: "Verificación del correo",
    verifying: "Verificando…",
    verified: "Su correo electrónico está verificado.",
    verifyFailed: "Este enlace de verificación no es válido o ha expirado.",
    passwordRule: "Mínimo 8 caracteres.",
    unverified: "Su correo electrónico aún no está verificado.",
    resend: "Reenviar el correo de verificación",
    resent: "Correo de verificación enviado.",
  },
  portal: {
    title: "Mi portal",
    welcome: "Hola",
    statusTitle: "Estado de mi expediente",
    noApplication: "Todavía no hay ninguna candidatura asociada a esta cuenta.",
    applyNow: "Enviar mi candidatura",
    currentStage: "Etapa actual",
    historyTitle: "Historial",
    profileTitle: "Mi perfil",
    accountTitle: "Mi cuenta",
    nextStepTitle: "Próxima etapa",
    nextStep: {
      new: "Su candidatura ha sido recibida. Nuestro equipo la está revisando.",
      to_contact: "Nuestro equipo se pondrá en contacto con usted próximamente.",
      contacted: "Se ha establecido un primer contacto. Esté atento a nuestros mensajes.",
      prequalification: "Una precalificación está en curso.",
      interview_scheduled: "Hay una reunión planificada con nuestro equipo.",
      interview_completed: "Su reunión ha finalizado. Nos comunicaremos con usted.",
      evaluation: "Su expediente está en evaluación.",
      orientation: "Estamos identificando la dirección profesional más coherente.",
      training: "Una etapa de formación está en curso.",
      ready_deployment: "Su expediente está listo para comenzar.",
      active: "Está activo dentro de nuestras actividades.",
      progressing: "Está progresando en su trayectoria.",
      not_retained: "Su expediente no ha sido retenido por el momento.",
      inactive: "Su expediente está actualmente inactivo.",
    },
    updated: "Perfil actualizado.",
    settingsLang: "Idioma de las comunicaciones",
  },
  admin: {
    dashboard: "Panel",
    candidates: "Candidatos",
    pipeline: "Pipeline",
    users: "Usuarios",
    audit: "Registro de auditoría",
    livechat: "Ask Vytali",
    contact: "Mensajes",
    recruitment: "Reclutamiento",
    settings: "Ajustes",
    kpi: { total: "Total de candidatos", new: "Nuevos candidatos", active: "Candidatos activos", unassigned: "Sin asignar" },
    byStage: "Candidatos por etapa",
    byVertical: "Candidatos por interés",
    byGeo: "Candidatos por territorio",
    bySource: "Candidatos por fuente",
    recent: "Candidaturas recientes",
    tasksDue: "Seguimientos pendientes",
    noTasks: "Ningún seguimiento pendiente.",
    scopeAssigned: "Alcance: sus candidatos asignados",
    scopeAll: "Alcance: todos los candidatos",
    table: { name: "Nombre", contact: "Contacto", location: "Territorio", stage: "Etapa", recruiter: "Reclutador", created: "Creado", interests: "Intereses", actions: "Acciones" },
    view: "Consultar",
    assignTo: "Asignar a",
    assignSuccess: "Asignación actualizada.",
    stageChanged: "Etapa actualizada.",
    candidateNotFound: "Candidato no encontrado o fuera de tu ámbito.",
    downloadDenied: "Descarga no permitida para este candidato.",
    accessDenied: "Acceso denegado: esta sección está reservada a los administradores.",
    claim: "Asumir el candidato",
    unassign: "Quitar la asignación",
    unassigned: "Sin asignar",
    changeStage: "Cambiar de etapa",
    stageReason: "Motivo (opcional)",
    notes: "Notas internas",
    addNote: "Añadir una nota",
    notePlaceholder: "Nota interna…",
    sensitive: "Nota sensible",
    noNotes: "Sin notas.",
    tasks: "Seguimientos",
    addTask: "Añadir un seguimiento",
    taskTitle: "Título del seguimiento",
    dueDate: "Vencimiento",
    markDone: "Marcar como completado",
    done: "Completado",
    open: "En curso",
    noTasksCandidate: "Sin seguimiento.",
    history: "Historial del pipeline",
    profile: "Perfil del candidato",
    experience: "Experiencia",
    consent: "Consentimientos",
    searchPlaceholder: "Nombre, correo, teléfono…",
    filterStage: "Etapa",
    filterVertical: "Interés",
    filterRecruiter: "Reclutador",
    filterCountry: "País",
    resultsCount: "resultado(s)",
    noResults: "Ningún candidato coincide con estos criterios.",
    usersTitle: "Usuarios y roles",
    role: "Rol",
    status: "Estado",
    activeLabel: "Activo",
    inactiveLabel: "Inactivo",
    lastSuperAdmin: "El último super_admin activo está protegido.",
    unassignedPool: "Candidatos sin asignar",
    auditTitle: "Registro de auditoría",
    auditActor: "Actor",
    auditAction: "Acción",
    auditEntity: "Entidad",
    auditDate: "Fecha",
    settingsCompany: "Empresa",
    settingsLanguages: "Idiomas",
    settingsRecruitment: "Reclutamiento",
    settingsEmail: "Correo",
    settingsPrivacy: "Privacidad",
    settingsSecurity: "Seguridad",
    settingsSaved: "Ajustes guardados.",
    securityNote: "Autenticación JWT, contraseñas con bcrypt, limitación de intentos, RBAC aplicado en el servidor.",
    emailNote: "La identidad del remitente se configura mediante variables de entorno y no es editable aquí.",
    privacyNote: "Los nombres de organizaciones privadas nunca se exponen públicamente sin autorización explícita.",
  },
  stages: {
    new: "Nuevo",
    to_contact: "Por contactar",
    contacted: "Contactado",
    prequalification: "Precalificación",
    interview_scheduled: "Entrevista planificada",
    interview_completed: "Entrevista completada",
    evaluation: "Evaluación",
    orientation: "Orientación",
    training: "Formación",
    ready_deployment: "Listo para incorporarse",
    active: "Activo",
    progressing: "En progresión",
    not_retained: "No retenido",
    inactive: "Inactivo",
  },
  verticals: {
    REAL_ESTATE: "Inmobiliario",
    INSURANCE_FINANCIAL_SERVICES: "Seguros y servicios financieros",
    SALES_CAMPAIGNS: "Ventas y campañas comerciales",
    CHARITY_CAMPAIGNS: "Campañas solidarias",
    AUTOMOTIVE: "Automotriz",
    BUSINESS_DEVELOPMENT: "Desarrollo de negocios",
    PROJECTS_PARTNERSHIPS: "Proyectos y alianzas",
  },
  documents: {
    title: "Mis documentos",
    rules: "Formatos aceptados",
    sizeUnit: "MB",
    type: "Tipo de documento",
    types: { resume: "Currículum", certification: "Certificación", other: "Otro documento" },
    upload: "Cargar un documento",
    uploaded: "Documento cargado.",
    deleted: "Documento eliminado.",
    failed: "La carga ha fallado.",
    errCode: {
      INVALID_FILE_TYPE: "Formato no aceptado. Permitidos: PDF, DOC, DOCX, JPG, JPEG, PNG.",
      INVALID_MIME: "El contenido del archivo no coincide con su extensión. Vuelva a guardar el documento e inténtelo de nuevo.",
      FILE_TOO_LARGE: "Archivo demasiado grande (máximo 8 MB). Comprima el PDF e inténtelo de nuevo.",
      EMPTY_FILE: "El archivo está vacío. Seleccione un documento válido.",
      INVALID_DOCUMENT_TYPE: "Tipo de documento no admitido.",
      STORAGE_UNAVAILABLE: "El almacenamiento de documentos no está disponible momentáneamente. Inténtelo de nuevo en unos instantes.",
      UNAUTHORIZED: "Su sesión ha caducado. Vuelva a iniciar sesión e inténtelo de nuevo.",
      CANDIDATE_NOT_FOUND: "No hay ninguna candidatura vinculada a esta cuenta: envíe primero su candidatura.",
      UPLOAD_FAILED: "La carga ha fallado. Inténtelo de nuevo en unos instantes.",
    },
    errType: "Formato no aceptado. Permitidos: PDF, DOC, DOCX, JPG, JPEG, PNG.",
    errSize: "Archivo demasiado grande. Tamaño máximo: 8 MB.",
    errInvalid: "Archivo no válido o vacío.",
    errAuth: "Debe iniciar sesión para cargar un documento.",
    empty: "Todavía no hay documentos.",
    download: "Descargar",
    delete: "Eliminar",
    staffTitle: "Documentos del candidato",
  },
  stats: {
    title: "Mis estadísticas",
    scope: "Alcance: su actividad personal",
    assigned: "Candidatos asignados",
    new7: "Nuevos (7 días)",
    openTasks: "Seguimientos abiertos",
    overdue: "Seguimientos vencidos",
    activity: "Actividad",
    moves7: "Cambios de etapa (7 d)",
    moves30: "Cambios de etapa (30 d)",
    notes30: "Notas (30 d)",
    claimed: "Candidatos asumidos",
    recentMoves: "Movimientos recientes",
  },
  footer: {
    tagline: "Proyectos. Personas. Crecimiento.",
    legal: "Legal",
    privacy: "Aviso de privacidad",
    terms: "Términos de uso",
    explore: "Explorar",
    organization: "Organización",
    account: "Cuenta",
    rights: "Todos los derechos reservados.",
    addressLabel: "Dirección oficial",
    address: "2828 Boul Laurier, Suite 700\nQuébec, QC G1V 0B9\nCanadá",
    confidentiality: "Consultants Sparks protege la confidencialidad de sus relaciones comerciales, socios y candidatos. Las oportunidades pueden variar según el perfil, la experiencia, las cualificaciones y las necesidades de las organizaciones.",
    navTitle: "Navegación",
    contactTitle: "Contacto",
    callUs: "Llámenos",
    phone: "+1 418-549-6833",
    askTitle: "Ask Vytali",
    askLead: "¿Una pregunta sobre una trayectoria, un proyecto o una alianza? Hágala y nuestro equipo le responderá.",
    askCta: "Hacer una pregunta",
    askSoon: "Haga su pregunta a Ask Vytali",
  },
  chat: {
    launcher: "Ask Vytali",
    open: "Abrir el chat Ask Vytali",
    callAria: "Llamar a Consultants Sparks",
    close: "Cerrar el chat Ask Vytali",
    subtitle: "Asistencia en directo · Consultants Sparks",
    placeholder: "Escriba su pregunta…",
    send: "Enviar",
    typing: "Ask Vytali está escribiendo…",
    error: "La conversación no está disponible por el momento. Puede llamarnos al +1 418-549-6833.",
    greeting: "Hola, soy Ask Vytali de Consultants Sparks. Un gusto conocerle. ¿Qué le trae por aquí hoy?",
    disclaimer: "Ask Vytali es una asistente conversacional. Este chat no emite ninguna decisión ni garantía de empleo, ingreso o entrevista.",
  },
};

export default es;
